import React from "react";
import { useSelector } from "react-redux";
import { Wrapper, MessageContainer } from "../../styled";
import WarningIcon from "../../../Icons/WarningIcon";
import { message } from "../../../../../store/General/selectors";

const WarningAlert = () => {
  const resultMessage = useSelector(message);
  return (
    <Wrapper>
      <WarningIcon />
      <MessageContainer>{resultMessage}</MessageContainer>
    </Wrapper>
  );
};

export default WarningAlert;
